var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 40,
    viewBox: "0 0 68 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0054C0.028 20.7204 0.3223 21.5468 0.8125 22.068L16.8125 39.0688C17.8967 40.0431 19.9757 40.4453 21.1875 39.3188C22.3811 38.2093 22.3456 36.0575 21.1565 34.9436L9.90651 23.0055H65C66.6568 23.0055 68 21.6623 68 20.0054C68 18.3485 66.6568 17.0052 65 17.0052H9.90651L21.1565 5.06712C22.1802 4.04162 22.3694 1.81413 21.1875 0.691933C20.0059 -0.430167 17.8522 -0.0716453 16.8125 0.942055L0.8125 17.9427C0.265 18.5245 -0.0018 19.2072 0 20.0054Z",
    fill: "#219EBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.baa6d9e8cfbc43d1b0fb041509f9d607.svg";
export { ForwardRef as ReactComponent };